<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-store" class="q-mb-sm" /> {{ $t('products') }}
        </div>

        <q-table :data="rewards" :columns="columnsOnView()" :pagination.sync="server_pagination" @request="request"
            :loading="loading" row-key="name" :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')" :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')" :rows-per-page-options="[5, 10, 50, 100]" binary-state-sort>

            <template slot="top" slot-scope="props" :props="props">
                <!-- <q-input :float-label="$t('guests_quantity')" dense v-model="qtyGuestsInvited" disable readonly /> -->
                <div class="col" />

                <q-btn color="secondary" icon="fas fa-plus" :label="$t('new')"
                    @click="$router.push({ name: 'admin_reward', params: { id: 0 } })" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>
                
                <q-td key="reward_product_type" :props="props">
                    {{ props.row.reward_product_type === 'voucher' ? $t('voucher') : $t('physical_product') }}
                </q-td>

                <q-td key="permissions" :props="props">
                    <q-btn color="primary" text-color="white" :label="getQuantity(props.row.permissions)" no-ripple>
                        <q-tooltip>
                            <p v-if="props.row.permissions.areas && props.row.permissions.areas.length" class="tooltip q-mb-sm">
                                {{ $t('areas') }}:
                                <span>
                                    {{ props.row.permissions.areas.map(a => getArea(a)).join(', ') }}
                                </span>
                            </p>
                            <p v-if="props.row.permissions.profiles && props.row.permissions.profiles.length" class="tooltip q-mb-sm">
                                {{ $t('profiles') }}:
                                <span>
                                    {{ props.row.permissions.profiles.map(a => getProfile(a)).join(', ') }}
                                </span>
                            </p>
                            <p v-if="props.row.permissions.user_group && props.row.permissions.user_group.length" class="tooltip q-mb-sm">
                                {{ $t('user_group') }}:
                                <span>
                                    {{ props.row.permissions.user_group.map(a => getGroup(a)).join(', ') }}
                                </span>
                            </p>
                        </q-tooltip>
                    </q-btn>
                </q-td>

                <q-td key="price" :props="props">
                    {{ props.row.price }}
                </q-td>

                <q-td key="must_be_approved" :props="props">
                    {{ props.row.must_be_approved ? $t('yes') : $t('no') }}
                </q-td>

                <q-td key="qty_in_stock" :props="props">
                    {{ props.row.qty_in_stock }}
                </q-td>

                <q-td key="qty_redemptions" :props="props">
                    {{ props.row.qty_redemptions }}
                </q-td>


                <q-td key="max_redemptions_per_user" :props="props">
                    {{ props.row.max_redemptions_per_user }}
                </q-td>

                <q-td key="timezone" :props="props">
                    {{ props.row.timezone }}
                </q-td>

                <q-td key="publish_date" :props="props">
                    {{ props.row.publish_date ? formatDate(props.row.publish_date) : '-' }}
                </q-td>

                <q-td key="unpublish_date" :props="props">
                    {{ props.row.unpublish_date ? formatDate(props.row.unpublish_date) : '-' }}
                </q-td>

                <q-td key="status" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)"
                        class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="far fa-list-alt"
                        @click="() => {
                            view_report_reward = true;
                            selected_product = props.row.id;
                            fetchProductById({ pagination: product_redeem_pagination });
                        }">
                        <q-tooltip>
                            {{ $t('view_redeem_history_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                    
                    <q-btn flat round color="primary" icon="fas fa-pencil-alt"
                        @click="$router.push({ name: 'admin_reward', params: { id: props.row.actions } })">
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
             <q-tr slot="bottom-row">
                <q-td colspan="100%">
                    <q-btn
                        flat
                        round
                        dense
                        color="secondary"
                        size="small"
                        icon="fas fa-cog"
                        @click="show_modal = true"
                    >
                        <q-tooltip>
                            {{ $t('configure_table_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <q-modal
			v-model="show_modal"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="saveColumns()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('personalize_columns') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-md">
						<div
							class="col-xs-12 col-sm-4"
							v-for="(column, index) in columns"
							:key="index"
							v-if="column.name !== 'actions' && column.name !== 'id'"
						>
							<q-checkbox v-model="column.show" :label="$t(column.label)" />
						</div>
					</div>

					<div class="row reverse gutter-md q-mt-md">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								icon="fas fa-times"
								color="primary"
								class="fit"
								:label="$t('close')"
								@click="saveColumns()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>


        <q-modal v-model="view_report_reward" :content-css="{ minWidth: '80vw' }">
            <q-modal-layout>
                <q-toolbar slot="header" color="white">
                    <q-toolbar-title  class="text-black flex justify-between">
                        {{ selected_product_name }}
                        <q-btn
                            flat
                            dense
                            v-close-overlay
                            icon="close"
                        />
                    </q-toolbar-title>
                </q-toolbar>

                <q-toolbar slot="header" color="white" class="justify-end">
                    <q-search class="q-my-md" v-model="search_product" color="white" @keyup.enter="fetchProductById({ pagination: product_redeem_pagination })" :label="$t('search')"/>
                </q-toolbar>

                <q-table :data="history_redeem" :columns="report_columns" row-key="id" flat
                    :pagination.sync="product_redeem_pagination" :loading="loading"
                    @request="fetchProductById" :no-data-label="$t('no_data_avaliable')"
                    :rows-per-page-options="[5, 10, 50, 100]"
                >
                    <template slot="body-cell-status_from" slot-scope="props">
                        <q-td :props="props">
                            <q-chip 
                                class="full-width"
                                :icon="getRedeemStatusIcon(props.row.status_from)"
                                :color="getRedeemStatusColor(props.row.status_from)">
                                {{ getRedeemStatus(props.row.status_from) || '-' }}
                            </q-chip>
                        </q-td>
                    </template>

                    <template slot="body-cell-status_to" slot-scope="props">
                        <q-td :props="props">
                            <q-chip
                                class="full-width"
                                :icon="getRedeemStatusIcon(props.row.status_to)"
                                :color="getRedeemStatusColor(props.row.status_to)">
                                {{ getRedeemStatus(props.row.status_to) || '-' }}
                            </q-chip>
                        </q-td>
                    </template>

                </q-table>

                
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import formatDate from './utils/formatDate'
import { getRedeemStatus, getRedeemStatusColor, getRedeemStatusIcon } from './utils/statusBadge'

export default {
    i18nOptions: { namespaces: ["custom", "rewards", "admin", "common", "users"] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            rewards: [],
            columns: [
                { name: 'id', required: true, label: '#', align: 'left', field: 'name', sortable: true, id: 1, show: true },
                { name: 'title', required: true, label: 'title', align: 'left', field: 'title', sortable: true, id: 2, show: true },
                { name: 'permissions', required: true, label: 'permissions', align: 'left', field: 'permissions', sortable: true, id: 3, show: true },
                { name: 'price', required: true, label: 'price', align: 'left', field: 'price', sortable: true, id: 7, show: true },
                { name: 'must_be_approved', required: true, label: 'must_be_approved', align: 'center', field: 'must_be_approved', sortable: true, id: 8, show: true },
                { name: 'qty_in_stock', required: true, label: 'stock', align: 'left', field: 'qty_in_stock', sortable: true, id: 9, show: true },
                { name: 'qty_redemptions', required: true, label: 'qty_redemptions', align: 'left', field: 'qty_redemptions', sortable: true, id: 10, show: true },
                { name: 'max_redemptions_per_user', required: true, label: 'max_redemptions_per_user', align: 'center', field: 'max_redemptions_per_user', sortable: true, id: 11, show: true },
                { name: 'timezone', required: true, label: 'timezone', align: 'center', field: 'timezone', sortable: true, id: 12, show: true },
                { name: 'publish_date', required: true, label: 'publish_date', align: 'center', field: 'publish_date', sortable: true, id: 13, show: true },
                { name: 'unpublish_date', required: true, label: 'unpublish_date', align: 'center', field: 'unpublish_date', sortable: true, id: 14, show: true },
                { name: 'status', required: true, label: 'status', align: 'center', field: 'status', sortable: true, id: 15, show: true },
                { name: 'actions', required: true, label: 'Ações', align: 'center', field: 'actions', sortable: false, id: 16, show: true }
            ],
            action_id: '',
            confirm_remove: false,
            show_report_reward: false,
            id: '',
            title: '',
            history_redeem: [],
            view_report_reward: false,
            report_columns: [
                { name: 'id', label: '#', field: 'id', align: 'left' },
                { name: 'user_approver_id', label: 'ID aprovador', field: 'user_approver_id', align: 'left' },
                { name: 'user_approver_email', label: 'Email do aprovador', field: 'user_approver_email', align: 'left' },
                { name: 'justification', label: 'Justificativa pública', field: 'justification', align: 'left' },
                { name: 'internal_comment', label: 'Observação Interna', field: 'internal_comment', align: 'left' },
                { name: 'reward_user_redemption', label: 'ID do usuário', field: 'reward_user_redemption', align: 'left' },
                { name: 'redeemed_user_email', label: 'Email do usuário', field: 'redeemed_user_email', align: 'left' },
                { name: 'created_date', label: 'Data do resgate', field: 'created_date', align: 'left', sortable: true },
                { name: 'status_from', label: 'Status De', field: 'status_from', align: 'left' },
                { name: 'status_to', label: 'Status Para', field: 'status_to', align: 'left' },
                { name: 'redemption_price', label: 'Valor', field: 'redemption_price', align: 'left' },
            ],
            product_redeem_pagination: {
                page: 1,
                rowsPerPage: 10,
                rowsNumber: 0,
                sortBy: null,
            },
            selected_product: null,
            selected_product_name: '',
            search_product: '',
            show_modal: false,
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            user_clients: 'common/user_clients',
            areas: 'registration_lists/country_areas',
			user_groups: 'registration_lists/group_users',
			profiles: 'registration_lists/profiles',
            store_columns: 'datatable_columns/store_columns',
            user_groups: 'registration_lists/group_users',
            profiles: 'registration_lists/profiles',
            tags: 'registration_lists/tags',
            reports: 'registration_lists/reports',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    getMaxWidth() {
        if (this.$q.platform.is.mobile) return '100vw'
        else return '80vw'
    },

    getMinWidth() {
        if (!this.$q.platform.is.mobile) return '90vw'
    },

    methods: {
        getRedeemStatusColor,
        getRedeemStatusIcon,
        getRedeemStatus,
        formatDate,
        columnsOnView() {
            return this.columns.filter(c => this.store_columns.includes(c.id))
        },
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_rewards_store/reward_products/?${this.$qs.stringify(data)}`, this.getHeader)
                .then(response => {
                    this.server_pagination.rowsNumber = response.data.count

                    this.rewards = response.data.results.map(r => {
                        return {
                            ...r, actions: r.id,
                            permissions: {
                                areas: r.areas,
                                profiles: r.profiles,
                                user_groups: r.user_groups,
                            }
                        }
                    })
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
                .then(response => {
                    this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                    this.$q.loading.hide()

                    this.request({
                        pagination: this.server_pagination
                    })
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
        },

        getArea(id) {
            let obj = this.areas.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getGroup(id) {
            let obj = this.user_groups.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },


       getProfile(id) {
            let obj = this.profiles.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_rewards_store/reward_products/${this.action_id}/`, this.getHeader)
                .then(() => {
                    this.request({
                        pagination: this.server_pagination
                    })

                    this.confirm_remove = false

                    this.$q.notify({
                        message: this.$t('item_removed_success'),
                        type: 'positive',
                        icon: 'far fa-trash-alt'
                    })
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
        },

        showReport(reward) {
            this.id = reward.id
            this.title = reward.title
            this.show_report_reward = true
        },

        getQuantity(permission) {
            return permission.areas.length + permission.profiles.length + permission.user_groups.length
        },

        hideReport() {
            this.show_report_reward = false
            this.id = ''
            this.title = ''
        },

        getStatus(status) {
            if (status == 1) return 'published'
            else if (status == 2) return 'unpublished'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        saveDatatableColumns() {
            if (this.columns.filter(c => c.show).length == 0)
                this.$store.dispatch('datatable_columns/SET_STORE_COLUMNS', [this.columns.map(c => c.id)])
            else
			    this.$store.dispatch('datatable_columns/SET_STORE_COLUMNS', [this.columns.filter(c => c.show || c.name === 'actions').map(c => c.id)])
		},

        saveColumns() {
			this.show_modal = false
			this.saveDatatableColumns()
		},

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        async fetchProductById({ pagination }) {
            this.$q.loading.show()

            this.selected_product_name = this.rewards.find(r => r.id === this.selected_product).title || ''

            const { page, rowsPerPage, sortBy, descending } = pagination
            this.product_redeem_pagination = pagination

            await this.$axios.get(`admin_rewards_store/reward_user_redemption_history/?reward_user_redemption__reward_product=${this.selected_product}`, {
                ...this.getHeader,
                params: {
                    page: page,
                    page_size: rowsPerPage,
                    ordering: sortBy ? (descending ? '-' + sortBy : sortBy) : null,
                    ...(this.search_product ? { search: this.search_product } : {}),
                }
            })
            .then(response => {
                    this.show_report_reward = true
                    this.history_redeem = response.data.results.map(r => {
                        return {
                            ...r,
                            created_date: r.created_date ? formatDate(r.created_date, this.id_user_language_selected) : null,
                        }
                    })
                    this.$q.loading.hide()
                })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        closeProductReport() {
            this.view_report_reward = false
            this.id = ''
            this.title = ''
        },
        
    },

    created() {
        this.loadPagination()
        this.fetchLists()

        if (this.store_columns.length == 0) {
            this.$store.dispatch('datatable_columns/SET_STORE_COLUMNS', [this.columns.map(c => c.id)])
        } else {
            this.columns = this.columns.map(c => {
                if (this.store_columns.includes(c.id) || c.name === 'actions') return { ...c, show: true }
                else return { ...c, show: false }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>
